'use server';

import { SessionService } from '@/contexts/authentication';
import { getStoryRepository } from '@/contexts/stories/repositories';
import type { Story } from '@/contexts/stories/types/story';

export interface GetStoriesResult {
  stories: Story[];
  total: number;
  hasMore: boolean;
}

export async function getStories(params?: {
  page?: number;
  pageSize?: number;
  status?: string;
  onlyFavorites?: boolean;
}): Promise<GetStoriesResult> {
  const familyId = await SessionService.getFamilyId();
  if (!familyId) return { stories: [], total: 0, hasMore: false };

  const page = params?.page ?? 1;
  const pageSize = params?.pageSize ?? 20;
  const offset = (page - 1) * pageSize;

  const result = await getStoryRepository().listByFamily({
    familyId,
    offset,
    limit: pageSize,
    status: params?.status as any,
    onlyFavorites: params?.onlyFavorites,
  });

  return {
    stories: result.stories as unknown as Story[],
    total: result.total,
    hasMore: offset + pageSize < result.total,
  };
}
